import { getReferrerAttribution } from "@outschool/attribution";
import {
  TrackNewBuyerAcquiredMutation,
  TrackNewBuyerAcquiredMutationVariables,
  TrackNewBuyerAcquiredProperties,
  TrackOrderCompletedMutation,
  TrackOrderCompletedMutationVariables,
  TrackOrderCompletedProperties
} from "@outschool/gql-frontend-generated";
import { gql, useMutation } from "@outschool/ui-apollo";
import React from "react";

const trackOrderCompletedMutation = gql`
  mutation TrackOrderCompleted($properties: TrackOrderCompletedProperties!) {
    trackOrderCompleted(properties: $properties)
  }
`;

export function useTrackOrderCompletedMutation() {
  const [trackOrderCompleted] = useMutation<
    TrackOrderCompletedMutation,
    TrackOrderCompletedMutationVariables
  >(trackOrderCompletedMutation);
  return React.useCallback(
    async (properties: TrackOrderCompletedProperties, anonymousId?: string) => {
      const { data } = await trackOrderCompleted({
        variables: {
          properties: {
            osRef: {
              ...getReferrerAttribution(),
              anonymousId
            },
            ...properties
          }
        }
      });

      if (!data) {
        throw new Error("No data returned");
      }
      return data.trackOrderCompleted;
    },
    [trackOrderCompleted]
  );
}

const trackNewBuyerAcquiredMutation = gql`
  mutation TrackNewBuyerAcquired(
    $properties: TrackNewBuyerAcquiredProperties!
  ) {
    trackNewBuyerAcquired(properties: $properties)
  }
`;

export function useTrackNewBuyerAcquiredMutation() {
  const [trackNewBuyerAcquired] = useMutation<
    TrackNewBuyerAcquiredMutation,
    TrackNewBuyerAcquiredMutationVariables
  >(trackNewBuyerAcquiredMutation);
  return React.useCallback(
    async (
      properties: TrackNewBuyerAcquiredProperties,
      anonymousId?: string
    ) => {
      const { data } = await trackNewBuyerAcquired({
        variables: {
          properties: {
            osRef: {
              ...getReferrerAttribution(),
              anonymousId
            },
            ...properties
          }
        }
      });
      if (!data) {
        throw new Error("No data returned");
      }
      return data.trackNewBuyerAcquired;
    },
    [trackNewBuyerAcquired]
  );
}
